module.exports = __webpack_public_path__ + "img/product24p.01521c38.png";